

import { globalContext } from 'context/global';
import React, { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { getAllData } from 'services/global';

const useNavModule = () => {

    const {currentModules} = useContext(globalContext)
    const [module,setModule] = useState('')
   

    const checkModule = (key)=> currentModules && !!currentModules.find(value =>value.system_module.name === key)



    useEffect(()=>{
        currentModules &&  setModule(currentModules)
    },[currentModules])

    return {module,checkModule}
}

export default useNavModule
